module.exports = "Functional Component\n\n- JS function\n\n- Accepts some inputs (called 'props')\n\n- Returns a React element\n\n-----------------------------------\n=> Can be written as an ES6 arrow function"


//////////////////
// WEBPACK FOOTER
// ./src/slides/10_components/notes_2.md
// module id = 614
// module chunks = 0